import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { EmbedPage } from './EmbedPage';
import { DemoPage } from './DemoPage';

function App() {
  const isEmbedMode = window.location.pathname === '/embed';
  
  if (isEmbedMode) {
    return <EmbedPage />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/embed" element={<EmbedPage />} />
        <Route path="/*" element={<DemoPage />} />
      </Routes>
    </Router>
  );
}

export default App